import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SystemIcon } from '@monorepo/nova-icons';
import {
  StyledDivider,
  StyledHeaderContainer,
  StyledSampleTag,
  StyledTitle,
  StyledTitleContainer,
} from '../styled';
import { CardHeaderProps } from '../types';

const StyledInfoButton = styled(IconButton)({
  padding: 0,
});

/**
 * Card Header Component
 * Displays the title, info icon, and sample count tag
 */
export const CardHeader: FC<CardHeaderProps> = ({
  title,
  sampleCount,
  inactiveDays,
  onInfoClick,
}) => {
  const { t } = useTranslation('communityStats');

  const handleInfoClick = () => {
    if (onInfoClick) {
      onInfoClick();
    }
  };

  return (
    <>
      <StyledHeaderContainer>
        <StyledTitleContainer>
          <StyledTitle>{title}</StyledTitle>
          <Tooltip
            title={t('directionalAgreement.infoTooltip')}
            arrow
            placement="top"
          >
            <StyledInfoButton size="small" onClick={handleInfoClick}>
              <SystemIcon iconName="Info" size={20} color="inherit" />
            </StyledInfoButton>
          </Tooltip>
        </StyledTitleContainer>

        {inactiveDays ? (
          <StyledSampleTag
            label={t('directionalAgreement.inactiveDays', {
              current: inactiveDays.current,
              total: inactiveDays.total,
            })}
          />
        ) : (
          <StyledSampleTag
            label={t('directionalAgreement.sampleCount', {
              count: sampleCount,
            })}
          />
        )}
      </StyledHeaderContainer>

      <StyledDivider />
    </>
  );
};
